import { useLingui } from '@lingui/react';
import { Box, Button, Image, rem } from '@mantine/core';
import { Icons } from '@/components/Shares/Icons';
import { MODAL, useModalAction } from '@/providers/ModalActionProvider';
import { useMediaQuery } from '@mantine/hooks';
import classes from './Header.module.css';
export const SignupButton = () => {
  const {
    i18n
  } = useLingui();
  const isMobile = useMediaQuery('(max-width: 88em)');
  const {
    setOpenModal
  } = useModalAction();
  return <Button c="dark" leftSection={<Icons className="icon-pr-line-log-in" fontSize={24} color="var(--mantine-color-dark-4)" />} tt="uppercase" fw={700} fz={{
    base: rem(10),
    sm: 'sm'
  }} size={isMobile ? 'sm' : 'md'} pos="relative" miw={{
    base: 142,
    sm: 184
  }} onClick={() => setOpenModal(MODAL.REGISTER)} classNames={{
    root: classes.signupButton,
    inner: classes.buttonInner
  }} rightSection={<Box pos="absolute" bottom={-1} right={1}>
          <Image src="/assets/avatar_user.png" alt="avatar" w={{
      base: 59,
      sm: 78
    }} h={{
      base: 48,
      sm: 64
    }} />
        </Box>}>
      {i18n._('Sign up')}
    </Button>;
};